import OutOfWordsModal from "components/layout/OutOfWordsModal";
import SelectPlanModal from "components/layout/SelectPlanModal";
import { CompanyContext } from "contexts/CompanyContext";
import { PriorityModalContext } from "contexts/PriorityModalContext";
import { SessionContext } from "contexts/SessionContext";
import { get, replace } from "lodash";
import { useContext, useEffect, useState } from "react";
import { api as Api } from "api/http";
import { replaceAll } from "utils/replaceAll";
import { formatSocialPostObj } from "../../formatSocialPostObj";
import { getSocialNetworkIntegration } from "utils/getSocialNetworkIntegration";

export const useLinkedin = () => {

    const { company, companySocials } = useContext(CompanyContext);

    const _start_date = new Date(new Date().getTime() - 30 * 24 * 3600 * 1000);
    const _end_date = new Date();

    const getLinkedinPosts = async (
        per_page = 100, // 100
        start_date = _start_date,
        end_date = _end_date
    ) => {
        const socialNetwork = getSocialNetworkIntegration("linkedin", companySocials);
        if (!socialNetwork) return [];

        // Default parameters only apply to `undefined`, and callers pass an explicit
        // `null` to mean "no date filter" (see PostContext), so fall back again here.
        // The dates only build the cache key — the posts endpoint isn't date-filtered.
        start_date = new Date(start_date || _start_date).toISOString();
        end_date = new Date(end_date || _end_date).toISOString();

        try {
            if (localStorage.getItem(`${company.id}_${socialNetwork.id}_${start_date.split("T")[0]}${end_date.split("T")[0]}`)) {
                return JSON.parse(localStorage.getItem(`${company.id}_${socialNetwork.id}_${start_date.split("T")[0]}${end_date.split("T")[0]}`));
            }
        } catch (err) {}

        let posts = [];
        try {
            posts = await Api.get(`/socialNetworks/${socialNetwork.id}/posts`).then(({ data: posts }) => { 
                if (!posts) posts = [];
                posts = posts?.map((post) => {
                    const media = [];
                    return formatSocialPostObj(
                        "linkedin",
                        post?.id,
                        socialNetwork?.external_id,
                        socialNetwork?.name,
                        socialNetwork?.username,
                        socialNetwork?.image?.url,
                        post?.createdAt,
                        post?.commentary,
                        media,
                        0,
                        0,
                        0,
                        0
                    )
                });
                localStorage.setItem(`${company.id}_${socialNetwork.id}_${start_date.split("T")[0]}${end_date.split("T")[0]}`, JSON.stringify(posts));
                return posts; 
            });
        } catch (err) {

        }
        return posts;
    }

    return { getLinkedinPosts }
}

